function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }
var id = 0;
function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }
import { elo as theme } from '../../themes';
import AriaTabTrap from './AriaTabTrap';
var _updateZindex = /*#__PURE__*/_classPrivateFieldLooseKey("updateZindex");
var _addEventListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addEventListeners");
var _removeEventListeners = /*#__PURE__*/_classPrivateFieldLooseKey("removeEventListeners");
var _setFocustToFirstElement = /*#__PURE__*/_classPrivateFieldLooseKey("setFocustToFirstElement");
var AriaModalAlert = function AriaModalAlert() {
  var _this = this;
  /**
   * Adiciona containers apenas a partir dos que precisam manter foco,
   * como uma Dialog, forçando que outros elementos como Alert abertos
   * após ela passem a manter foco até que sejam fechados
   * @param {*} containerRef
   * @returns
   */
  this.addContainer = function (containerRef, backdropRef, handleEsc) {
    var lastActiveContainer = _this.getCurrentContainer();
    if (lastActiveContainer) {
      _classPrivateFieldLooseBase(_this, _removeEventListeners)[_removeEventListeners](lastActiveContainer);
    }
    var newContainer = {
      containerRef: containerRef,
      backdropRef: backdropRef,
      ariaModalAlertInstance: _this,
      previousActiveElement: document.activeElement,
      handleEsc: handleEsc
    };
    _this.openContainerList.push(newContainer);
    _classPrivateFieldLooseBase(_this, _updateZindex)[_updateZindex](newContainer);
    _classPrivateFieldLooseBase(_this, _addEventListeners)[_addEventListeners](newContainer);
    _this.ariaTabTrap.bracketContainerWithFocusableNodes(containerRef);
    _classPrivateFieldLooseBase(_this, _setFocustToFirstElement)[_setFocustToFirstElement](containerRef);
  };
  this.removeContainer = function () {
    if (_this.openContainerList.length) {
      var currentContainer = _this.getCurrentContainer();
      if (!currentContainer) {
        return;
      }
      if (currentContainer.ariaModalAlertInstance === _this) {
        _classPrivateFieldLooseBase(_this, _removeEventListeners)[_removeEventListeners](currentContainer);
        _this.openContainerList.pop();
        var lastActiveContainer = _this.getCurrentContainer();
        if (lastActiveContainer) {
          _classPrivateFieldLooseBase(_this, _addEventListeners)[_addEventListeners](lastActiveContainer);
        }
        try {
          currentContainer.previousActiveElement.focus();
        } catch (error) {
          // ignore error
        }
      }
    }
  };
  Object.defineProperty(this, _updateZindex, {
    writable: true,
    value: function value(newContainer) {
      if (newContainer.backdropRef && _this.openContainerList.length > 1) {
        var countIndex = _this.openContainerList.length - 1;
        var container = newContainer;
        container.containerRef.style.zIndex = theme.zIndex.contentMask + countIndex;
        container.backdropRef.style.zIndex = theme.zIndex.mask + countIndex;
      }
    }
  });
  Object.defineProperty(this, _addEventListeners, {
    writable: true,
    value: function value(container) {
      document.addEventListener('focus', container.ariaModalAlertInstance.trapFocus, true);
      document.addEventListener('keydown', container.handleEsc, false);
    }
  });
  Object.defineProperty(this, _removeEventListeners, {
    writable: true,
    value: function value(container) {
      document.removeEventListener('focus', container.ariaModalAlertInstance.trapFocus, true);
      document.removeEventListener('keydown', container.handleEsc, false);
    }
  });
  Object.defineProperty(this, _setFocustToFirstElement, {
    writable: true,
    value: function value(element) {
      var me = _this;
      setTimeout(function () {
        me.ariaTabTrap.focusFirstDescendant(element);
      }, 1);
    }
  });
  this.getCurrentContainer = function () {
    if (_this.openContainerList.length) {
      return _this.openContainerList[_this.openContainerList.length - 1];
    }
    return undefined;
  };
  this.trapFocus = function (event) {
    _this.ariaTabTrap.trapFocus(event);
  };
  if (AriaModalAlert.singleton) {
    return AriaModalAlert.singleton;
  }
  this.openContainerList = [];
  this.ariaTabTrap = new AriaTabTrap(this.getCurrentContainer);
  AriaModalAlert.singleton = this;
};
export default AriaModalAlert;